import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { startCase } from 'lodash/string';
import Form from '../../../../../components/Form';
import Input from '../../../../../components/Input';
import InputRestictMarkup from '../../../../../components/InputRestictMarkup';
import WYSIWYG from '../../../../../components/WYSIWYG';
import messages from '../messages';
import elementIds from '../elementIds';
import FieldError from '../FieldError';
import '../styles.css';

const ProfileFacultyForm = ({ personsName, quote, body, errors, onChange, formatMessage, type }) => (
  <React.Fragment>
    <Form.Field required error={errors.personsName} styleName="form-field name-field">
      <label className="form-label" htmlFor={elementIds.personsName}>
        <FormattedMessage {...messages.persons_name} />
      </label>
      <Input
        styleName="form-input"
        type="text"
        id={elementIds.personsName}
        aria-invalid={errors.personsName}
        aria-required="true"
        name="personsName"
        value={personsName}
        onChange={onChange}
        fluid
      />
      {errors.personsName && <FieldError message={messages.invalid_persons_name} />}
    </Form.Field>
    <Form.Field required error={errors.quote} styleName="form-field">
      <label className="form-label" htmlFor={elementIds.quote}>
        <FormattedMessage {...messages.quote} />
      </label>
      <InputRestictMarkup
        styleName="form-input"
        type="text"
        id={elementIds.quote}
        aria-invalid={errors.quote}
        aria-required="true"
        name="quote"
        value={quote}
        placeholder={formatMessage(messages.quote_placeholder)}
        onChange={onChange}
        fluid
      />
      {errors.quote && <FieldError message={messages.invalid_quote} />}
    </Form.Field>
    <Form.Field required error={errors.body} styleName="form-field body">
      <label className="form-label" htmlFor={elementIds.body}>
        <FormattedMessage values={{ type: startCase(type) }} {...messages.about_faculty_member} />
      </label>
      <WYSIWYG
        className="edit-modal-wysiwyg-container"
        styleName="form-wysiwyg"
        id={elementIds.body}
        aria-invalid={errors.body}
        aria-required="true"
        name="body"
        type="textarea"
        limit={0}
        mode="extended"
        value={body}
        onChange={onChange}
        placeholder={formatMessage(messages.about_placeholder)}
        fluid
      />
      {errors.body && <FieldError message={messages.invalid_about_faculty_member} />}
    </Form.Field>
  </React.Fragment>
);

ProfileFacultyForm.propTypes = {
  personsName: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default ProfileFacultyForm;
